export enum PriceRibbonDayTileType {
  LoadingPrice = 'loadingPrice',
  LoadedPrice = 'loadedPrice',
  NoAvailability = 'noAvailability',
  AlternativePrice = 'alternativePrice',
}

export interface PriceRibbonDayLoadingPriceTile {
  type: PriceRibbonDayTileType.LoadingPrice;
}

export interface PriceRibbonDayLoadedPriceTile {
  type: PriceRibbonDayTileType.LoadedPrice;
  priceWithCurrency: string;
}

export interface PriceRibbonAlternativePriceTile {
  type: PriceRibbonDayTileType.AlternativePrice;
  priceWithCurrency: string;
}

export interface PriceRibbonDayNoAvailabilityTile {
  type: PriceRibbonDayTileType.NoAvailability;
}

export type PriceRibbonDayTile =
  | PriceRibbonDayLoadingPriceTile
  | PriceRibbonDayLoadedPriceTile
  | PriceRibbonAlternativePriceTile
  | PriceRibbonDayNoAvailabilityTile;

export interface PriceRibbonDay {
  date: string;
  dayMonth: string;
  weekday: string;
  // TODO: use enum instead of 2 booleans
  isSelected: boolean;
  isSuggested: boolean;
  state: PriceRibbonDayTile;
}

export interface PriceRibbonMonth {
  month: string;
  monthShort: string;
  year: string;
  isExtended: boolean;
  firstDayInMonthISO: string;
  days: PriceRibbonDay[];
}
